(() => {
  const searchPath = `${window.Shopify?.routes?.root || '/'}search`;
  const url = new URL(window.location.href);
  if (url.pathname.replace(/\/$/, '') === searchPath && url.searchParams.has('q') && url.searchParams.get('type') !== 'product') {
    url.searchParams.set('type', 'product');
    window.location.replace(url.toString());
    return;
  }
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = (root = document) => {
    root.querySelectorAll('[data-search-examples]').forEach(input => {
      if (input.dataset.examplesReady) return;
      input.dataset.examplesReady = 'true';
      const phrases = input.dataset.searchExamples.split('|').filter(Boolean);
      if (!phrases.length) return;
      const fallback = input.placeholder;
      let phrase = 0, length = 0, deleting = false, timer;
      const stop = () => window.clearTimeout(timer);
      const paused = () => motion.matches || document.hidden || document.activeElement === input || input.value.length > 0 || !input.isConnected;
      const tick = () => {
        stop();
        if (paused()) return;
        const text = phrases[phrase];
        length += deleting ? -1 : 1;
        input.placeholder = text.slice(0, length) || ' ';
        let delay = deleting ? 35 : 75;
        if (length === text.length) { deleting = true; delay = 2100; }
        else if (length === 0) { deleting = false; phrase = (phrase + 1) % phrases.length; delay = 300; }
        timer = window.setTimeout(tick, delay);
      };
      const resume = () => {
        stop();
        if (paused()) { input.placeholder = fallback; return; }
        length = 0; deleting = false;
        input.placeholder = fallback;
        timer = window.setTimeout(tick, 900);
      };
      input.addEventListener('focus', () => { stop(); input.placeholder = fallback; });
      input.addEventListener('input', stop);
      input.addEventListener('blur', resume);
      document.addEventListener('visibilitychange', resume);
      motion.addEventListener('change', resume);
      resume();
    });
    root.querySelectorAll('.ix-nav-header').forEach(header => {
      if (header.dataset.ixReady) return;
      header.dataset.ixReady = 'true';
      const details = header.querySelector('.ix-nav-shop');
      const close = () => { if (details) details.open = false; };
      document.addEventListener('click', event => { if (details?.open && !details.contains(event.target)) close(); });
      header.addEventListener('keydown', event => { if (event.key === 'Escape' && details?.open) { close(); details.querySelector('summary').focus(); } });
      details?.addEventListener('click', event => { if (event.target.closest('a[href]')) close(); });
      header.addEventListener('focusout', () => window.setTimeout(() => { if (details?.open && !details.contains(document.activeElement)) close(); }, 0));
      header.querySelector('input[type="search"]')?.addEventListener('focus', close);
      const mobile = header.querySelector('menu-drawer > details');
      mobile?.addEventListener('keydown', event => {
        if (event.key !== 'Tab' || !mobile.open) return;
        const items = [...mobile.querySelector('.mobile-menu').querySelectorAll('a[href],button')];
        if (event.shiftKey && document.activeElement === items[0]) { event.preventDefault(); items.at(-1).focus(); }
        else if (!event.shiftKey && document.activeElement === items.at(-1)) { event.preventDefault(); items[0].focus(); }
      });
      mobile?.addEventListener('toggle', () => { if (mobile.open) mobile.querySelector('[data-menu-close]').focus(); });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
